import { getDaysArray } from '@tesla/design-system';
import { useMemo } from 'react';
/**
 * useCalendarGrid
 * - Generate a 7x6 grid of dates representing the current month of the given date
 * @param {Date} date - A date to build the month grid around
 * // Numbers correspond to days of the week, starting with 0/Sunday
 * @param {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7} firstDayOfWeek - First day of week for building calendar grid
 * @return {Date[]} days - An array of dates representing the current month
 */
export const useCalendarGrid = (date, firstDayOfWeek = 0) => {
    const days = useMemo(() => getDaysArray(date, firstDayOfWeek), [date, firstDayOfWeek]);
    return days;
};
